import { createContext, useContext } from "react";
import { ContextProviderProps } from "./interfaces";
import "react-toastify/dist/ReactToastify.css";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface HandleErrorContextType {
  handleError: (err: Error | AxiosError, type: string) => void;
}

export const ErrorContext = createContext({} as HandleErrorContextType);
export const useErrorContext = () => useContext(ErrorContext);

export const ErrorContextProvider = ({ children }: ContextProviderProps) => {
  const { t } = useTranslation();

  const handleError = (err: any, type: string) => {
    if (err?.code === "ERR_CANCELED") {
      // Do nothing, as axios request was canceled
      return;
    }
    console.log(err);

    toast(`${t(`message.error${type}`)}`, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "error",
    });

    // TODO: Redirecting based on error (unauth -> login, refresh page etc.) ?
  };

  return (
    <ErrorContext.Provider
      value={{
        handleError,
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
};
